import { render, staticRenderFns } from "./CustomElm.vue?vue&type=template&id=0586b682&scoped=true"
import script from "./CustomElm.vue?vue&type=script&lang=js"
export * from "./CustomElm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586b682",
  null
  
)

export default component.exports